module.exports = __webpack_public_path__ + "static/media/serv-10.13d97b71.jpg";